import React from "react";

const LanguageButton = ({ language, onClick, selected }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-4 py-3 rounded-lg border transition
        ${
          selected
            ? "border-yellow-500 bg-yellow-50"
            : "border-gray-300 bg-white"
        }
        hover:border-yellow-500`}
    >
      <span className="text-gray-700 font-medium">{language.display_name}</span>
    </button>
  );
};

export default LanguageButton;
